import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Card,
  CardContent,
  Typography,
  CardMedia,
  Divider,
} from "@mui/material";
import { useRecoilValue} from "recoil";
import { userInformationAtom } from "../../Services/_states";
import { ConstantActions } from "../../Services/_actions";

interface WhatsAppApiModalProps {
  onClose: () => void;
  appName: string | null; 
}

const modalStyle: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  backgroundColor: "#ffffff",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "12px",
  padding: "20px",
};

const WhatsAppApiModal: React.FC<WhatsAppApiModalProps> = ({ onClose,appName }) => {
  const userInfo = useRecoilValue(userInformationAtom);
  const company_id = userInfo?.profile?.organisation?.organisation_id;
  const actions = ConstantActions();
  const [payload, setPayload] = useState({});

  // Load Facebook SDK on component mount
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      window.FB?.init({
        appId: "1222044378809517",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v21.0",
      });
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Facebook login callback
  const fbLoginCallback = (response: any) => {
    console.log('App Name in fbLoginCallback:', appName);
    console.log("fbLoginCallbackResponse", response);
    if (response.authResponse) {
      const { code } = response.authResponse;
      console.log('Authorization Code:', code);
      const updatedPayload = { ...payload, code:code };
      setPayload((prevPayload) => ({
        ...prevPayload,
        code
      }));
    }
  };

  // Launch WhatsApp signup process
  const launchWhatsAppSignup = () => {
    window.FB?.login(fbLoginCallback, {
      config_id: "505651552549076",
      response_type: "code",
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: "",
        sessionInfoVersion: "3",
      },
    });
  };

  // API call to fetch access token
  const fetchAccessTokenFromBackend = async (data: any) => {
    console.log('App Name:', appName); 
  console.log('Payload Before Sending:', data);
    try {
      const updatedData = { ...data, app_name: appName, company_id };
      console.log('Updated Payload with app_name:', updatedData);
      const response = await actions.postFacebookData(updatedData);
      console.log('Backend Response:', response); 

      console.log(response, "3242342342342")
    } catch (error) {
      console.error(error, "Error while sending data to backend");
    }
    localStorage.removeItem('updatedPayload');
  };

  const handleMessage = (event: MessageEvent) => {
    if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") {
      return;
    }

    try {
      let data:any;
      const result = {};
      try {
        data = JSON.parse(event?.data);
      } catch (jsonError) {
        const queryString =event?.data;
        const params = new URLSearchParams(queryString);
        for (const [key, value] of params.entries()) {
          result[key] = value;
        }
        console.log(result,"result")
        const localData = JSON.parse(localStorage.getItem("updatedPayload"));
        const { phone_number_id, waba_id } = localData;
        const updatedPayload = { ...payload, ...result, phone_number_id, waba_id, company_id };
        fetchAccessTokenFromBackend(updatedPayload);
        setPayload(updatedPayload);
      }
      if (data?.type === "WA_EMBEDDED_SIGNUP") {
        if (data?.event === "FINISH") {
          const { phone_number_id, waba_id } = data.data;
          const updatedPayload = {...payload,phone_number_id, waba_id };
          localStorage.setItem('updatedPayload', JSON.stringify(updatedPayload));
          setPayload(updatedPayload);
        } else if (data.event === "CANCEL") {
          console.log("UserCancelled", data?.data);
        } else if (data.event === "ERROR") {
          console.log("SignupError", data?.data);
        }
      }
    } catch (error) {
      console.log("UnexpectedError", error);
    }
  }
  // Handle messages from Facebook
  useEffect(() => {

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <Modal open onClose={onClose} aria-labelledby="modal-title">
      <Box style={modalStyle}>
        <Card elevation={0} style={{ borderRadius: "12px" }}>
          <CardContent>
            <Typography
              id="modal-title"
              variant="h5"
              component="h2"
              style={{ fontWeight: "bold", textAlign: "center", marginBottom: "20px" }}
            >
              Apply for WhatsApp Business API
            </Typography>
            <Typography variant="body1" style={{ textAlign: "center", marginBottom: "10px" }}>
              Click on <strong>Continue With Facebook</strong> to apply for WhatsApp Business API.
            </Typography>
            <Divider style={{ margin: "20px 0" }} />
            <Typography variant="body2" style={{ textAlign: "center", color: "#555555" }}>
              Requirements:
              <ul style={{ listStyleType: "disc", textAlign: "left", margin: "10px 20px" }}>
                <li>A Registered Business</li>
                <li>A Working Website</li>
              </ul>
            </Typography>
            <Box style={{ textAlign: "center", marginBottom: "20px" }}>
              <Button
                href="#"
                size="small"
                variant="outlined"
                color="primary"
                style={{ textTransform: "none" }}
              >
                How to apply for WhatsApp Business API?
              </Button>
            </Box>
            <CardMedia
              component="iframe"
              src="https://www.youtube.com/embed/VIDEO_ID"
              title="Apply for WhatsApp Business API"
              style={{
                width: "100%",
                height: "200px",
                border: "none",
                marginBottom: "20px",
                borderRadius: "8px",
              }}
            />
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Button
                variant="outlined"
                color="secondary"
                onClick={onClose}
                style={{
                  textTransform: "none",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  fontWeight: "bold",
                }}
              >
                Migrate from another vendor
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={launchWhatsAppSignup}
                style={{
                  textTransform: "none",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  fontWeight: "bold",
                }}
              >
                Continue With Facebook
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

export default WhatsAppApiModal;
